<template>
  <v-col
    v-if="attribute.type == 'multiselect'"
    cols="8"
    class="pa-0"
  >
    <v-list subheader>
      <v-list-item-group>
        <v-list-item
          v-for="(type, index) in dicts[attribute.name]"
          :key="index"
        >
          <template v-slot:default>
            <v-list-item-action>
              <v-checkbox
                :readonly="!canEdit"
                :disabled="isCopied"
                v-model="attribute.value"
                color="primary"
                :value="type"
              />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ type[$i18n.locale] }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-col>
</template>

<script>
export default {
  props: {
    attribute: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isCopied: {
      type: Boolean,
      default: false,
      required: false
    },
    dicts: {
      type: Object,
      required: true
    }
  },
  mounted() {
    // Obsługa atrybutów których typem wartości jest coś innego niż Array
    // Jak pole było jeszcze 'single selectem', było przechowywane jako objekt, teraz jest listą objektów
    if (!Array.isArray(this.attribute.value)) {
      if (
        typeof this.attribute.value === 'object' &&
        this.attribute.value !== null
      ) {
        let ob = this.attribute.value;
        this.attribute.value = [ob];
      } else {
        this.attribute.value = [];
      }
    } else {
      if (this.attribute.value.length === 1) {
        if (
          this.attribute.value[0].pl === null &&
          this.attribute.value[0].en === null
        ) {
          this.attribute.value = [];
        }
      }
    }
  }
};
</script>